@use 'ui/styles/core-tokens' as core;

.summary {
  &EnvVars {
    display: flex;
    flex-direction: column;
    gap: 10px;

    &:not(:last-child) {
      margin-bottom: 20px;
    }

    .title {
      margin-bottom: 2px;
    }
  }
}
